module.exports = __webpack_public_path__ + "img/9788996373759.267b371e.jpg";